module.exports = __webpack_public_path__ + "static/media/-_performance management.f7137289.png";